
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personalrummet/ntc",
      function () {
        return require("private-next-pages/personalrummet/ntc.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personalrummet/ntc"])
      });
    }
  